/** @jsx jsx */
import { Flex, Grid, Heading, Link, Paragraph } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { LazyUserAvatar } from "@/components/avatars";
import { CollapsibleArea, CollapsibleButton, useCollapsible } from "@/components/collapsible";
import { ResponsiveCard } from "@/components/ResponsiveCard";
import { formatFullName } from "@/data/persons";
import { formatPhone } from "@/data/phones";
import { TimeReport } from "@/data/time-reports";

interface TimeReportSummaryHiringManagerProps {
  timeReport: TimeReport;
}

export const TimeReportSummaryHiringManager: FC<TimeReportSummaryHiringManagerProps> = ({ timeReport }) => {
  const { t } = useTranslation("session");

  const hiringManager = timeReport.hiringManager;
  const collapsibleState = useCollapsible(false);

  return (
    <ResponsiveCard sx={{ py: ["sm", "sm", "sm", "md"] }}>
      <Grid gap="sm">
        <Flex justifyContent="space-between" alignItems="center">
          <Heading size="h-sm">{t("TIME_REPORTS.SUMMARY.HIRING_MANAGER.HEADER")}</Heading>
          <CollapsibleButton {...collapsibleState} />
        </Flex>

        <CollapsibleArea {...collapsibleState}>
          <Flex gap="xs">
            <LazyUserAvatar user={hiringManager} size="lg" />

            <Flex flexDirection="column">
              <Paragraph bold>{formatFullName(hiringManager)}</Paragraph>

              {hiringManager.phone && <Paragraph color="n700">{formatPhone(hiringManager.phone)}</Paragraph>}

              <Paragraph color="n700">
                <Link as="a" href={`mailto:${hiringManager.email}`}>
                  {hiringManager.email}
                </Link>
              </Paragraph>
            </Flex>
          </Flex>
        </CollapsibleArea>
      </Grid>
    </ResponsiveCard>
  );
};
